import { Tag, Tooltip } from 'antd';
import { MdAltRoute } from 'react-icons/md';

const MultiPickingBadge = () => (
    <Tooltip title="Multi Picking">
        <Tag
            color="cyan"
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 2,
                marginInlineEnd: 0,
                padding: '0 5px',
                fontSize: 10,
                lineHeight: '16px',
            }}
        >
            <MdAltRoute size={11} />
            Multi
        </Tag>
    </Tooltip>
);

export { MultiPickingBadge };
